import { Grid } from "@mui/material";

import useGetPageInfo from "../../common/hooks/useGetPageInfo";
import Dashboard from "../../components/dashboard";
import BreadcrumbsComponent from "../../components/shared/breadcrumbs";

const SLNPage = () => {
  const pageInfo = useGetPageInfo();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Dashboard menuList={pageInfo.child} cartTitle={pageInfo.title} />
      </Grid>
    </Grid>
  );
};

export default SLNPage;
